"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = require("./Message");
const id_1 = require("../id/id");
const ExpandedNodeId_1 = __importDefault(require("../ua/ExpandedNodeId"));
const NodeId_1 = require("../ua/NodeId");
const SecureConversationMessageHeader_1 = __importDefault(require("./SecureConversationMessageHeader"));
const MessageType_1 = require("./MessageType");
const ChunkType_1 = require("./ChunkType");
const SequenceHeader_1 = __importDefault(require("./SequenceHeader"));
const AsymmetricSecurityHeader_1 = __importDefault(require("./AsymmetricSecurityHeader"));
const Connection_1 = __importDefault(require("../uacp/Connection"));
const decode_1 = __importDefault(require("../ua/decode"));
// import OpenSecureChannelResponse from '../ua/OpenSecureChannelResponse'
const SecurityTokenRequestType_1 = require("../ua/SecurityTokenRequestType");
const generated_1 = require("../ua/generated");
const SymmetricSecurityHeader_1 = __importDefault(require("./SymmetricSecurityHeader"));
class SecureChannel extends EventTarget {
    constructor(options) {
        var _a, _b, _c, _d;
        super();
        this.onack = () => {
            // open secure channel
            const open = new generated_1.OpenSecureChannelRequest({
                RequestHeader: new generated_1.RequestHeader({
                    RequestHandle: 0
                }),
                RequestType: SecurityTokenRequestType_1.SecurityTokenRequestTypeIssue,
                SecurityMode: generated_1.MessageSecurityModeNone,
                RequestedLifetime: 3600000
            });
            this.send(open);
        };
        this.send = (request, resolve) => {
            // set auth token if we already have one
            if (this.authenticationToken) {
                request.RequestHeader.AuthenticationToken = this.authenticationToken;
            }
            // get type id from constructor name
            const typeId = id_1.mapNameToId.get(request.constructor.name + 'EncodingDefaultBinary');
            const message = new Message_1.Message({
                ChunkHeader: new Message_1.ChunkHeader({
                    Header: new SecureConversationMessageHeader_1.default({
                        IsFinal: ChunkType_1.ChunkTypeFinal,
                        SecureChannelId: this.secureChannelId
                    }),
                    SequenceHeader: new SequenceHeader_1.default({
                        SequenceNumber: this.sequenceNumber += 1,
                        RequestId: this.requestId += 1
                    })
                }),
                TypeId: new ExpandedNodeId_1.default({
                    NodeId: NodeId_1.NewFourByteNodeId(0, typeId)
                }),
                Service: request
            });
            // store resolve function for request id
            if (resolve) {
                this.callbacks.set(this.requestId, resolve);
            }
            // set message type and security header
            switch (typeId) {
                case id_1.IdOpenSecureChannelRequestEncodingDefaultBinary:
                    message.ChunkHeader.Header.MessageType = MessageType_1.MessageTypeOpenSecureChannel;
                    message.ChunkHeader.SecurityHeader = new AsymmetricSecurityHeader_1.default();
                    break;
                default:
                    message.ChunkHeader.Header.MessageType = MessageType_1.MessageTypeMessage;
                    message.ChunkHeader.SecurityHeader = new SymmetricSecurityHeader_1.default({
                        TokenId: this.securityTokenId
                    });
                    break;
            }
            // encode and send
            const body = message.encode();
            this.connection.socket.send(new Uint8Array(body));
        };
        this.sendfoo = (request) => {
            const message = new Message_1.Message({
                ChunkHeader: new Message_1.ChunkHeader({
                    Header: new SecureConversationMessageHeader_1.default({
                        MessageType: MessageType_1.MessageTypeMessage,
                        IsFinal: ChunkType_1.ChunkTypeFinal,
                        SecureChannelId: this.secureChannelId
                    }),
                    SecurityHeader: new SymmetricSecurityHeader_1.default({
                        TokenId: this.securityTokenId
                    }),
                    // AsymmetricSecurityHeader: new AsymmetricSecurityHeader(),
                    SequenceHeader: new SequenceHeader_1.default({
                        SequenceNumber: this.sequenceNumber += 1,
                        RequestId: this.requestId += 1
                    })
                }),
                TypeId: new ExpandedNodeId_1.default({
                    NodeId: NodeId_1.NewFourByteNodeId(0, id_1.IdCreateSessionRequestEncodingDefaultBinary)
                }),
                Service: request
            });
            const body = message.encode();
            this.connection.socket.send(new Uint8Array(body));
        };
        this.sendactivate = (request) => {
            const message = new Message_1.Message({
                ChunkHeader: new Message_1.ChunkHeader({
                    Header: new SecureConversationMessageHeader_1.default({
                        MessageType: MessageType_1.MessageTypeMessage,
                        IsFinal: ChunkType_1.ChunkTypeFinal,
                        SecureChannelId: this.secureChannelId
                    }),
                    SecurityHeader: new SymmetricSecurityHeader_1.default({
                        TokenId: this.securityTokenId
                    }),
                    SequenceHeader: new SequenceHeader_1.default({
                        SequenceNumber: this.sequenceNumber += 1,
                        RequestId: this.requestId += 1
                    })
                }),
                TypeId: new ExpandedNodeId_1.default({
                    NodeId: NodeId_1.NewFourByteNodeId(0, id_1.IdActivateSessionRequestEncodingDefaultBinary)
                }),
                Service: request
            });
            const body = message.encode();
            this.connection.socket.send(new Uint8Array(body));
        };
        this.onmessage = (event) => {
            const header = new Message_1.ChunkHeader();
            let offset = header.decode(event.data);
            switch (header.Header.MessageType) {
                case 'OPN': {
                    const typeId = new ExpandedNodeId_1.default();
                    offset = decode_1.default({
                        bytes: event.data,
                        instance: typeId,
                        position: offset
                    });
                    const response = new generated_1.OpenSecureChannelResponse();
                    offset = decode_1.default({
                        bytes: event.data,
                        instance: response,
                        position: offset
                    });
                    this.secureChannelId = response.SecurityToken.ChannelId;
                    this.securityTokenId = response.SecurityToken.TokenId;
                    // create session
                    const create = new generated_1.CreateSessionRequest({});
                    // const open = new OpenSecureChannelRequest({
                    //   RequestHeader: new RequestHeader({
                    //     RequestHandle: 0
                    //   }),
                    //   RequestType: SecurityTokenRequestTypeIssue,
                    //   SecurityMode: MessageSecurityModeNone,
                    //   RequestedLifetime: 3600000
                    // })
                    this.sendfoo(create);
                    break;
                }
                case 'MSG': {
                    const typeId = new ExpandedNodeId_1.default();
                    offset = decode_1.default({
                        bytes: event.data,
                        instance: typeId,
                        position: offset
                    });
                    if (typeId.NodeId.Identifier ===
                        id_1.IdCreateSessionResponseEncodingDefaultBinary) {
                        const response = new generated_1.CreateSessionResponse();
                        offset = decode_1.default({
                            bytes: event.data,
                            instance: response,
                            position: offset
                        });
                        this.authenticationToken = response.AuthenticationToken;
                        const activate = new generated_1.ActivateSessionRequest({
                            RequestHeader: new generated_1.RequestHeader({
                                AuthenticationToken: this.authenticationToken
                            })
                        });
                        this.sendactivate(activate);
                    }
                    else if (typeId.NodeId.Identifier ===
                        id_1.IdActivateSessionResponseEncodingDefaultBinary) {
                        const activateSessionResponse = new generated_1.ActivateSessionResponse();
                        decode_1.default({
                            bytes: event.data,
                            instance: activateSessionResponse,
                            position: offset
                        });
                        this.dispatchEvent(new Event('session:activate'));
                    }
                    else {
                        const callback = this.callbacks.get(header.SequenceHeader.RequestId);
                        if (callback) {
                            const response = new generated_1.BrowseResponse();
                            decode_1.default({
                                bytes: event.data,
                                instance: response,
                                position: offset
                            });
                            callback(response);
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        };
        this.secureChannelId = 0;
        this.sequenceNumber = 0;
        this.securityTokenId = 0;
        this.requestId = 0;
        this.connection = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.connection, (_b !== null && _b !== void 0 ? _b : new Connection_1.default({ endpoint: 'ws://localhost:1234' })));
        this.authenticationToken = null;
        (_c = this.connection) === null || _c === void 0 ? void 0 : _c.socket.addEventListener('message', this.onmessage);
        (_d = this.connection) === null || _d === void 0 ? void 0 : _d.addEventListener('ack', this.onack);
        this.callbacks = new Map();
    }
}
exports.default = SecureChannel;
